import {
  keys,
  pickBy,
  castArray,
  uniqBy,
  reduce,
} from 'lodash';
import { convertDatesToFilters } from './date';

const DEFAULT_RELEASE_SORTBY = 'datereleased';
const DEFAULT_ACTOR_SORTBY = 'recentlyactive';
const DEFAULT_SEARCH_SORTBY = 'relevance';
const DEFAULT_DATE = 'any';
const DEFAULT_GENDER = 'any';
export const DEFAULT_GENDERS = ['female', 'male', 'other'];
export const DEFAULT_CONTENT_TYPE = 'scene';
export const DEFAULT_SELECTED_TAB = 'sortby';

const DATE_FILTERS = [
  {
    name: 'anytime',
    value: 'any',
    key: 'any',
  },
  {
    name: 'last week',
    value: 'thisweek',
    key: 'thisweek',
  },
  {
    name: 'last month',
    value: 'thismonth',
    key: 'thismonth',
  },
  {
    name: 'last year',
    value: 'thisyear',
    key: 'thisyear',
  },
];

export const SORT_OPTIONS_ACTORS = [
  {
    name: 'relevance',
    value: 'relevance',
    key: 'relevance',
  },
  {
    name: 'recently active',
    value: 'recentlyactive',
    key: 'recentlyactive',
  },
  {
    name: 'number of videos',
    value: 'videos',
    key: 'numbervideos',
  },
  {
    name: 'top rated',
    value: 'rating',
    key: 'toprated',
  },
  {
    name: 'alphabetical',
    value: 'alpha',
    key: 'alpha',
  },
  {
    name: 'number of views',
    value: 'views',
    key: 'mostviewed',
  },
];

export const keyMap = {
  site: 'availableCollections',
  groups: 'availableGroups',
  models: 'availableActors',
  tags: 'availableTags',

};

export const SORT_OPTIONS_RELEASES = [
  {
    name: 'relevance',
    value: 'relevance',
    key: 'relevance',
  },
  {
    name: 'release date',
    value: 'datereleased',
    key: 'date',
  },
  {
    name: 'top rated',
    value: 'rating',
    key: 'toprated',
  },
  {
    name: 'most viewed',
    value: 'views',
    key: 'mostviewed',
  },
  {
    name: 'title',
    value: 'title',
    key: 'title',
  },
];

export const DEFAULT_THEME = {
  color: {
    background: '#000000',
    blockBgColor: '#ffffff',
    dropdownTextColor: '#ffffff',
    primary: '#37b2a0',
    text: '#fefefe',
    menuBg: '#000',
  },
};

export const getDefaultParams = (type) => {
  if (type === 'actors') {
    return {
      sortby: window.location.search.includes('q=') ? DEFAULT_SEARCH_SORTBY : DEFAULT_ACTOR_SORTBY,
      date: DEFAULT_DATE,
      gender: DEFAULT_GENDER,
    };
  }
  return {
    sortby: window.location.search.includes('q=') ? DEFAULT_SEARCH_SORTBY : DEFAULT_RELEASE_SORTBY,
    date: DEFAULT_DATE,
  };
};

export const additionalFiltersObj = {
  addon: {
    label: 'My Content',
    primary: 142,
    values: [
      { id: 162, name: 'Brazzers 1', contentGroupIds: [5] },
      { id: 142, name: 'DP 1 (primary)', contentGroupIds: [9] },
      { id: 164, name: 'Brazzers 2', contentGroupIds: [5] },
      { id: 144, name: 'DigitalPlayground 2', contentGroupIds: [9] },
      { id: 165, name: 'Brazzers 3', contentGroupIds: [5] },
      { id: 145, name: 'DigitalPlayground 3', contentGroupIds: [9] },
      { id: 166, name: 'Brazzers 4', contentGroupIds: [5] },
      { id: 566, name: 'DigitalPlayground 4', contentGroupIds: [9] },
      { id: 567, name: 'Brazzers 5', contentGroupIds: [5] },
      { id: 547, name: 'DigitalPlayground 5', contentGroupIds: [9] },
      { id: 568, name: 'Brazzers 6', contentGroupIds: [5] },
      { id: 548, name: 'Very Very Very Long Long Name', contentGroupIds: [9] },
    ],
  },
  purchasableAddon: {
    label: 'Additional Content',
    values: [
      { name: 'EliteXXX', id: 2472, contentGroupIds: [2051] },
      { name: 'Mile High Premium', id: 1352, contentGroupIds: [474] },
      { id: 145, name: 'DigitalPlayground', contentGroupIds: [9] },
      { id: 166, name: 'Brazzers A', contentGroupIds: [5] },
      { id: 146, name: 'DigitalPlayground A', contentGroupIds: [9] },
      { id: 167, name: 'Brazzers B', contentGroupIds: [5] },
      { id: 147, name: 'DigitalPlayground B', contentGroupIds: [9] },
      { id: 167, name: 'Brazzers C', contentGroupIds: [5] },
      { id: 148, name: 'Very Very Very Long Long Name', contentGroupIds: [9] },
    ],
  },
};

export const getGendersOptions = (genders) => (
  genders
    ? genders.map((key) => ({
      id: key,
      value: key,
      key,
      name: key,
    }))
    : []
);

const getModifiedSorting = (originalSorting, hasFilterData, contentType) => {
  if (hasFilterData && contentType === 'actors') {
    return {
      relevance: true,
      toprated: true,
    };
  }
  if (hasFilterData && contentType === 'scene') {
    return {
      relevance: true,
      date: true,
    };
  }

  return originalSorting;
};

const getAvailableGenders = (genderOptions) => (
  genderOptions && Object.entries(genderOptions)
    .filter(([, val]) => Boolean(val))
    .map(([key]) => key)
);

const valueToArray = (value) => {
  if (typeof value === 'string') {
    // RK style "?models=123,456" and BZ style "/models/123+456/"
    return value.length > 0 ? value.split(/,|\+/) : [];
  }
  if (!value) {
    return [];
  }
  return castArray(value.toString());
};

// enable relevance sort option for search queries
const getSortOptions = (sortOptions, sorting) => {
  const nextSorting = { ...sorting };
  if (window.location.search.includes('q=')) {
    nextSorting.relevance = true;
  }

  return sortOptions?.filter((option) => nextSorting?.[option.key]);
};

// on search V1, we will have addon and purchasableAddon
// on searchV2, we have only addon
// additionalFilters = {
//     "addon": {
//       "label": "My Content",
//       "values": [{addonId:162}, {addonId:152},{addonId:192}],
//       "primary": 162
//   },
//   "purchasableAddon": {
//       "label": "Additional Content",
//       "values": [//some data of brands]
//   }
// }
const getActiveSubscription = ({
  additionalFilters, activeFilter, key, hasFilterData,
}) => {
  // when on search v2, on initial load when no subscriptions are selected from My Content  by default we will
  // set activeValue as array of all available brand Ids ( activeValue= ['162', '152', '192']), as we have
  // records of all brands in initial response. which will show all the addons as selected on initial load
  if (hasFilterData && valueToArray(activeFilter.get('addon'))?.length === 0) {
    return additionalFilters.addon.values.map((id) => String(id.addonId));
  }

  // when on search v2, after the initial load, if he deselects checkbox of My Content
  // from getNextActiveValue of checkBoxlist.js, we will set nextActiveValue to ['null']
  // in that case we will set activeValue to [], to show all the brands as unchecked
  if (hasFilterData && activeFilter.get('addon')?.[0] === null) {
    return [];
  }
  // when on search v1, on initial load when no subscriptions are selected by default we will set active value to
  // primary, as we have records of only that brand in the response (activeValue = ['162'])
  if (valueToArray(activeFilter.get('addon'))?.length === 0
    && valueToArray(activeFilter.get('purchasableAddon'))?.length === 0
    && key === 'addon'
    && additionalFilters?.addon?.primary) {
    return [String(additionalFilters.addon.primary)];
  }
  // if the user check selects or deselects some brands depending on that we will update array of activeValue
  // activeValue =['162', '192']
  return valueToArray(activeFilter.get(key));
};

// highlight primary bundle if none selected
const getDefaultSelectedBundleValue = (activeFilter) => {
  if (valueToArray(activeFilter.get('addon')).length === 0
    && valueToArray(activeFilter.get('purchasableAddon')).length === 0) {
    return ['0']; // hacky way to ensure top level bubble always shows at least 1 (primary)
  }
  return [...valueToArray(activeFilter.get('addon')), ...valueToArray(activeFilter.get('purchasableAddon'))];
};

export const getActorsDisplayOption = (actors = [], genders, showFirstNamesOnly) => {
  let displayedGenders = Array.isArray(genders) ? [...genders] : [genders];

  displayedGenders = displayedGenders.length < DEFAULT_GENDERS.length
    ? [...actors].filter((actor) => displayedGenders.includes(actor.gender))
    : [...actors];

  return showFirstNamesOnly
    ? displayedGenders.map((actor) => ({ id: actor.id, name: actor.name.split(' ')[0] }))
    : displayedGenders;
};

const updateKeys = (filterKeys, objects, mapping) => filterKeys.filter((key) => mapping[key] in objects);

export const createFilters = (
  config,
  activeFilter,
  contentFilter,
  defaultFilters,
  additionalFilters,
  gendersOfModelsToShow,
  showFirstNamesOnly,
  hasFilterData,
) => {
  if (!config || !activeFilter || !contentFilter) return {};
  const { sorting, contentType } = config;
  let { filterOptions } = config;

  if (hasFilterData && contentType === 'actors') {
    filterOptions = {
      tags: filterOptions.tags,
      tagsLabel: filterOptions.tagsLabel,
      subscriptionsLabel: filterOptions.subscriptionsLabel,
      gender: filterOptions.gender,
      genderOptions: filterOptions.genderOptions,
    };
  }

  const sortOptions = contentType === 'actors'
    ? SORT_OPTIONS_ACTORS
    : SORT_OPTIONS_RELEASES;
  const modifiedSorting = getModifiedSorting(sorting, hasFilterData, contentType);
  const additionalSelectedKeys = keys(pickBy(additionalFilters));
  const selectedKeys = additionalSelectedKeys?.length
    ? keys(pickBy(filterOptions))?.concat(additionalSelectedKeys).filter((value) => value !== 'site')
    : keys(pickBy(filterOptions));

  if (filterOptions?.subscriptions || filterOptions?.subscriptions === undefined) {
    selectedKeys.push('subscriptions');
  }

  const multiSelectFilters = [
    {
      key: 'site',
      options: contentFilter?.availableCollections,
      label: filterOptions?.siteLabel || 'Site/Collection',
      activeValue: valueToArray(activeFilter.get('site')),
      defaultValue: defaultFilters?.site,
      type: 'InputListWidget',
    },
    {
      key: 'groups',
      options: contentFilter?.availableGroups,
      label: filterOptions?.groupsLabel || 'Groups',
      activeValue: valueToArray(activeFilter.get('groups')),
      defaultValue: defaultFilters?.groups,
      type: 'InputListWidget',
    },
    {
      key: 'models',
      options: getActorsDisplayOption(contentFilter?.availableActors, gendersOfModelsToShow, showFirstNamesOnly)
        ?.sort((a, b) => (a.name < b.name ? -1 : 1)),
      label: filterOptions?.modelsLabel || 'Models',
      subtitle: 'All models',
      activeValue: valueToArray(activeFilter.get('models')),
      defaultValue: defaultFilters?.models,
      type: 'InputListWidget',
    },
    {
      key: 'tags',
      options: uniqBy(contentFilter?.availableTags?.sort((a, b) => (a.name < b.name ? -1 : 1)), 'id'),
      label: filterOptions?.tagsLabel || 'Categories',
      activeValue: valueToArray(activeFilter.get('tags')),
      defaultValue: defaultFilters?.tags,
      type: 'InputListWidget',
    },
    {
      key: 'subscriptions',
      options: [],
      label: filterOptions?.subscriptionsLabel || 'Subscriptions',
      activeValue: getDefaultSelectedBundleValue(activeFilter, additionalFilters),
      defaultValue: defaultFilters?.addon,
      type: 'InputListWidget',
    },
  ];
  const singleSelectFilter = {
    gender: {
      key: 'gender',
      options: getGendersOptions(filterOptions?.genderOptions),
      label: filterOptions?.genderLabel || 'Gender',
      availableValues: getAvailableGenders(contentFilter?.availableGenders),
      activeValue: activeFilter.get('gender'),
      defaultValue: defaultFilters?.gender,
      type: 'RadioBtnWidget',
    },
    date: {
      key: 'date',
      options: hasFilterData
        ? [
          ...DATE_FILTERS,
          {
            name: 'today',
            value: 'thisday',
            key: 'thisday',
          },
        ] : DATE_FILTERS,
      availableValues: convertDatesToFilters(contentFilter?.availableDates, hasFilterData),
      label: filterOptions?.dateLabel || 'Date Range',
      activeValue: activeFilter.get('date'),
      defaultValue: defaultFilters?.date,
    },
  };
  const subscriptions = additionalFilters
    ? reduce(additionalFilters, (res, val, key) => {
      res.push(
        {
          key,
          options: uniqBy(val?.values, 'id'),
          label: val?.label,
          activeValue: getActiveSubscription({
            additionalFilters, activeFilter, key, hasFilterData,
          }),
          defaultValue: defaultFilters?.[key],
          hasFilterData,
          type: 'CheckboxWidget',
        },
      );
      return res;
    }, [])
    : [];

  const ddSelectedKeys = updateKeys(selectedKeys, contentFilter, keyMap)
    .concat(selectedKeys.includes('subscriptions') ? ['subscriptions'] : []);

  const filteredMultiSelectFilters = multiSelectFilters
    .filter(((item) => (hasFilterData ? ddSelectedKeys : selectedKeys).includes(item.key)));

  return {
    sort: {
      key: 'sortby',
      options: getSortOptions(sortOptions, modifiedSorting),
      label: sorting?.customLabel || 'Sort By',
      activeValue: activeFilter.get('sortby'),
      type: 'FilterOptions',
      single: true,
      defaultValue: defaultFilters?.sortby,
    },
    multiSelect: filteredMultiSelectFilters,
    ...(selectedKeys.includes('date') ? { date: { ...singleSelectFilter.date } } : {}),
    ...(selectedKeys.includes('gender') && !hasFilterData ? { gender: { ...singleSelectFilter.gender } } : {}),
    ...(subscriptions?.length && selectedKeys.includes('subscriptions')
      ? {
        subscriptions: {
          key: 'subscriptions',
          label: filterOptions?.subscriptionsLabel || 'Subscriptions',
          type: 'CheckboxWidget',
          options: [...subscriptions],
        },
      } : {}),
  };
};
